import { tracked } from '@glimmer/tracking';
import Constants from '../../utils/constants';
import { TEMPERATURE_RANGE } from '../../utils/formulas';
import cloneDeep from 'lodash.clonedeep';

export default class DefaultAmp {
  cdpParameters;
  @tracked config;
  @tracked resistor;
  @tracked selected;
  @tracked useInUrl;
  constructor(result) {
    if (result) {
      this.cdpParameters = result.cdpParameters;
      this.config = result.config;
      this.resistor = result.resistor;
      this.selected = result.selected;
      this.useInUrl = true;
    } else {
      console.error('default-amp constructed without passing a result');
    }
  }

  clone() {
    let result = new DefaultAmp({
      cdpParameters: cloneDeep(this.cdpParameters),
      config: cloneDeep(this.config),
      resistor: this.resistor?.clone(),
      selected: cloneDeep(this.selected),
    });
    result.isCurrent = this.isCurrent;
    return result;
  }

  get selectedTemperatureRange() {
    const paramKey = Constants.CDP.PARAMETERS.TEMPERATURE_RANGE;
    if (!(this.selected && paramKey in this.selected)) return { min: null, max: null };

    const tempRange = this.selected[paramKey];

    if (tempRange.value && tempRange.value.length) {
      return TEMPERATURE_RANGE(tempRange.value[0]);
    } else {
      return {
        min: null,
        max: null,
      };
    }
  }

  get id() {
    return this.config ? this.config.id : null;
  }

  get isBuffer() {
    return (this.config && this.config.isBuffer) || false;
  }

  get isNonInverting() {
    return (this.config && this.config.isNonInverting) || false;
  }

  get isInverting() {
    return (this.config && this.config.isInverting) || false;
  }

  get isVoltageReference() {
    return (this.config && this.config.isVoltageReference) || false;
  }

  get isInternal() {
    return (this.config && this.config.isInternal) || false;
  }
}
